import { ThemeOverride, theme as base } from "@chakra-ui/react";

const fonts: ThemeOverride["fonts"] = {
	heading: `Droid Arabic Kufi, ${base.fonts.heading}`,
	body: `Droid Arabic Kufi, ${base.fonts.body}`,
};

export default fonts;
